module.exports = __webpack_public_path__ + "static/img/bksq.65d6bbe4.png";